import type { ComponentProps } from 'react';
import { useOccurrenceExport } from '../../../hooks/useOccurrenceExport';
import { buildExportFilters } from '../../../utils/kanbanUtils';
import type ExportProgressKanbanDialog from '../../exportProgressKanbanDialog';
import type { TrackingPersona } from '../trackingUtils';
import type { OccurrenceState } from '../types';

type ExportDialogStage = ComponentProps<typeof ExportProgressKanbanDialog>['stage'];

const useTrackingExport = (occurrences: OccurrenceState, persona: TrackingPersona) => {
    const { open, stage, progress, detail, errorMessage, close, exportWithFilters } = useOccurrenceExport();

    const handleExport = async () => {
        const {
            criticalityFilter,
            typeFilter,
            startDateFilter,
            updateDateFilter,
            dealershipFilter,
            regionalFilter,
            cellFilter,
            modelFilter,
            stepFilter,
            stepTypeCurrentFilter,
            finishedFilter,
            isAlertFilter,
            cpvNameFilter,
            searchFieldName,
            searchFieldValue,
            chassisListFilterByStep,
            chassisListFilter,
            chassisFilter,
        } = occurrences;
        const exportFilters = buildExportFilters(
            {
                criticalityFilter,
                typeFilter,
                startDateFilter,
                updateDateFilter,
                dealershipFilter,
                regionalFilter,
                cellFilter,
                modelFilter,
                stepFilter,
                stepTypeCurrentFilter,
                finishedFilter,
                isAlertFilter,
                cpvNameFilter,
                searchFieldName,
                searchFieldValue,
                chassisListFilterByStep,
            },
            [...new Set([...chassisListFilter, ...(searchFieldValue ? [] : [chassisFilter])].filter(Boolean))]
        );
        await exportWithFilters({
            filters: exportFilters,
            filename: `kanban_${new Date().toISOString().slice(0, 10)}.xlsx`,
            userRole: persona,
        });
    };

    const dialogProps = {
        show: open,
        stage: ((stage as unknown) === 'paging' ? 'writing' : stage) as ExportDialogStage,
        progress,
        detail,
        errorMessage,
        onClose: close,
    };

    return { handleExport, dialogProps };
};

export default useTrackingExport;
